<template>
  <div class="row">
    <div class="col-12">
      <simple-table title="Users"
                    url="/entity/users"
                    :columns="tableColumns"
                    :actions="actions"
                    :add-enabled="true"
                    :is-entity="true"></simple-table>
    </div>
  </div>
</template>
<script>
import SimpleTable from "../../../components/Beast/Table/SimpleTable.vue";

export default {
  components: {
    SimpleTable,
  },
  data() {
    return {
      tableColumns: [
        {
          class: "beast-user-table-gravatarHash",
          label: "",
          minWidth: 50,
          field: "gravatarHash",
          template: hash => `<img src="https://gravatar.com/avatar/${hash}" class="img-thumbnail"/>`
        },
        {
          class: "beast-user-table-fullName",
          label: "Full Name",
          minWidth: 100,
          field: "fullName",
        },
        {
          class: "beast-user-table-username",
          label: "Username",
          minWidth: 100,
          field: "username"
        },
        {
          class: "beast-user-table-email",
          label: "Email",
          minWidth: 100,
          field: "email"
        },
        {
          class: "beast-user-table-systemRole",
          label: "Role",
          minWidth: 100,
          field: "systemRole"
        },
      ],
      actions: [
        {
          label: "View",
          icon: "search",
          class: "btn-link text-info",
          href: "view/:id"
        },
        {
          label: "Edit",
          icon: "edit",
          class: "btn-link text-warning",
          href: "view/:id?edit=true"
        },
        {
          label: "Delete",
          icon: "times",
          class: "btn-link text-danger",
          key: "id",
          value: "fullName",
          delete: true
        }
      ]
    };
  },
};
</script>
<style>
  .beast-user-table-gravatarHash{
    width: 7%;
  }
  .beast-user-table-fullName{
    width: 20%;
  }
  .beast-user-table-username{
    width: 20%;
  }
  .beast-user-table-email{
    width: 30%;
  }
  .beast-user-table-systemRole{
    width: 15%;
  }
</style>
